export default __webpack_public_path__ + "static/media/Bracers of Tribulation.dea06f25.jpg";